export default __webpack_public_path__ + "static/media/courses.135d34a0.svg";